import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import qrcode from '../assets/QRcode.png';
import ButtonStore from '../components/ButtonStore';

function Download() {

  React.useEffect(() => {
    var _mtm = (window._mtm = window._mtm || []);
    _mtm.push({ "mtm.startTime": new Date().getTime(), event: "mtm.Start" });
    var d = document,
    g = d.createElement("script"),
    s = d.getElementsByTagName("script")[0];
    g.async = true;
    g.src = "https://analytics.preprod.qalmo.fr/js/container_LnaaM1aY.js";
    s.parentNode.insertBefore(g, s);
  }, []);

  const playStoreURL = 'https://play.google.com/store/apps/details?id=com.frdev.qalmo';
  const appStoreURL = 'https://apps.apple.com/fr/app/qalmo/id6502453401';

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isAndroid = /android/i.test(userAgent);
  const isiOS = /iPhone|iPad|iPod/i.test(userAgent);

  if (isAndroid) {
    window.location.href = playStoreURL;
    return null;
  } else if (isiOS) {
    window.location.href = appStoreURL;
    return null;
  }

  return (
    <div className="h-screen flex flex-col font-fraunces">
      <Header />
      <div className="flex flex-col lg:flex-row items-center justify-center flex-1 p-6 lg:px-16">
        <div className="mt-4 flex-1 lg:flex-none lg:w-1/2 space-y-10 lg:space-y-14 text-center mx-auto lg:ml-16">
          <h1 className="text-2xl lg:text-7xl">
            Télécharger <br />
            <span className='text-qalmo'>qalmo</span> pour <br />
            iOS/Android <br />
          </h1>
          <div className="flex flex-row justify-center space-x-4 lg:justify-center">
            <div>
              <Link to="/ios">
                <ButtonStore store="ios"/>
              </Link>
            </div>
            <div>
              <Link to="/android">
                <ButtonStore store="googleplay" />
              </Link>
            </div>
          </div>
        </div>
        <div className="flex w-full justify-center lg:justify-center items-center">
          <div>
            <img src={qrcode} width="400" alt="qrcode" className='shadow-2xl rounded-2xl'/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Download;